export enum JJTErrorCodes {
  // oracle connection errors
  ORACLE_CREATE_CONNECTION = 100,
  ORACLE_CLOSE_CONNECTION = 110,
  ORACLE_ROLLBACK = 120,

  // QueryFactory errors
  QUERY_MISSING = 200,
  QUERY_REFRESH = 210,

  // model errors
  // client
  MODEL_GET_CLIENT = 1000,

  // period
  MODEL_GET_CURRENT_PERIOD = 1010,

  // provisions
  MODEL_GET_ALL_COMPANY_CODES = 1020,
  MODEL_PROVISION_CALCULATE_BATCH = 1030,


  // sequence
  MODEL_GET_SEQUENCE = 1030,

  // trial balance
  MODEL_GET_TRIAL_BALANCE_BY_PARAMS = 1100,
  MODEL_INSERT_NON_ES_TRIAL_BALANCE = 1110,
  MODEL_INSERT_ES_TRIAL_BALANCE = 1120,
  MODEL_RESET_TRIAL_BALANCE = 1130,
  MODEL_PROCESS_TRIAL_BALANCE = 1140,
  MODEL_GET_BALANCE_COUNT_VALID = 1150,
  MODEL_START_TRIAL_BALANCE_BATCH_UPLOAD_PROCESS = 1160,
  MODEL_END_TRIAL_BALANCE_BATCH_UPLOAD_PROCESS = 1161,
  MODEL_LOG_BATCH_TRIAL_BALANCE_PROCESSING_STEP = 1170,


  // connection
  MODEL_UPDATE_CONNECTION_STATUS = 1200,
  MODEL_UPDATE_CONNECTION_HEALTH_STATUS = 1210,

  // account
  MODEL_GET_TLS_ACCOUNT_LIST_ERROR = 1300,

  // validation errors
  ROW_LEVEL_VALIDATION = 2000,
  ROW_LEVEL_SCHEMA_VALIDATION = 2005,
  DATASET_LEVEL_VALIDATION = 2100,

  // specific validation errors
  VALIDATION_COLUMN_VALIDATION = 3000,
  VALIDATION_INCORRECT_COMPANY_CODE = 3010,
  VALIDATION_INCORRECT_PERIOD = 3020,

  // job specific errors
  // trial balance
  NO_VALID_TRIAL_BALANCE_IMPORTED = 4100,
}
